import React from "react";
import {StyledButton, Wrapper} from "./CandidateLayer.styles";
import {useHistory} from "react-router-dom";
import {useStore} from "../../../../../hooks/useStore";
// import {WhatsappSupportButton} from "../../../../_defaultComponents/WhatsappSupportButton/WhatsappSupportButton";
export const CandidateLayer = () => {
    const history = useHistory();
    const stores = useStore();

    const toLogout = async () => {
        await stores.appStore.setLoading(true);
        await stores.meStore.logout();
        await history.push("/login");
        await stores.appStore.setLoading(false);
    };
    if (!stores.meStore.checkRole("isCandidateCustomer")) {
        return <></>;
    }

    return (
        <>
            <Wrapper>
                <div>
                    <b>Hoşgeldiniz!</b>
                    <br />
                    <br />
                    Aktivasyon işleminiz için operasyon destek ekibimiz en
                    <br /> kısa zamanda sizinle iletişime geçecektir
                </div>

                <StyledButton size="xl" onClick={() => toLogout()}>
                    Çıkış Yap
                </StyledButton>
            </Wrapper>
            {/* <WhatsappSupportButton /> */}
        </>
    );
};
